module.exports = __webpack_public_path__ + "img/lbr.309ccbd8.svg";